import React from 'react';

import Timebasetest from '../../components/timebasetest/Timebasetest';

import styles from '../../styles/timebase-testseries.module.scss';

const index = () => (
  <div className={styles.timebase_test_container}>
    <Timebasetest />
  </div>
);

export default index;
